import React from 'react';
import { useFormikContext } from 'formik';
import { FormGroup } from '../../form';
import { InputText, InputPassword } from '../../formikBindings';

const ReceptionLoginForm: React.FC = () => {
  const { isSubmitting } = useFormikContext();

  return (
    <>
      <FormGroup name="pin" label="PIN">
        <InputText name="pin" disabled={isSubmitting} autoFocus />
      </FormGroup>
      <FormGroup name="password" label="Password">
        <InputPassword name="password" disabled={isSubmitting} />
      </FormGroup>
    </>
  );
};

export default ReceptionLoginForm;
